import React from 'react';
import { useSelector } from 'react-redux';
import { SummaryLabelledInfo } from '../labelled-info';
import { buyOrderPeopleSelectors } from '../../../../../admin/buy-process/people/people-redux';
import { RootState } from '../../../../../../global';
import { ClientInfoStoreState } from '../../../client-info';

interface SummaryClientProps {
  clientInfo: ClientInfoStoreState;
  orderId: string;
}

export const SummaryClient = ({ clientInfo, orderId }: SummaryClientProps) => {
  const { person, email, phoneNumber, organizationName } = clientInfo;

  const personProperties = useSelector((state: RootState) => {
    if (!person) return null;
    return buyOrderPeopleSelectors.selectById(
      state.buyOrderPeople[orderId],
      person,
    );
  });

  return (
    <React.Fragment>
      <SummaryLabelledInfo label="Förnamn">
        {personProperties?.firstName}
      </SummaryLabelledInfo>
      <SummaryLabelledInfo label="Efternamn">
        {personProperties?.lastName}
      </SummaryLabelledInfo>
      <SummaryLabelledInfo label="Personnummer">
        {personProperties?.socialSecurityNumber}
      </SummaryLabelledInfo>
      <SummaryLabelledInfo label="Företagsnamn">
        {organizationName}
      </SummaryLabelledInfo>
      <SummaryLabelledInfo label="Utdelningsadress">
        {personProperties?.address}
      </SummaryLabelledInfo>
      <SummaryLabelledInfo label="Postnummer">
        {personProperties?.postalCode}
      </SummaryLabelledInfo>
      <SummaryLabelledInfo label="Ort">
        {personProperties?.city}
      </SummaryLabelledInfo>
      <SummaryLabelledInfo label="Telefon">{phoneNumber}</SummaryLabelledInfo>
      <SummaryLabelledInfo label="E-postadress">{email}</SummaryLabelledInfo>
      <SummaryLabelledInfo label="Bekräfta e-post">{email}</SummaryLabelledInfo>
    </React.Fragment>
  );
};
